import { render, staticRenderFns } from "./ApplicableShopsPoi.vue?vue&type=template&id=6d3d6ecd&scoped=true"
import script from "./ApplicableShopsPoi.vue?vue&type=script&lang=ts"
export * from "./ApplicableShopsPoi.vue?vue&type=script&lang=ts"
import style0 from "./ApplicableShopsPoi.vue?vue&type=style&index=0&id=6d3d6ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d6ecd",
  null
  
)

export default component.exports